import { Box, Button } from '@deckee/deck-hand';
import React, { FC } from 'react';
import SheetModal from '../../../shared/SheetModal/SheetModal';

interface HideNotificationSheetProps {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const HideNotificationSheet: FC<HideNotificationSheetProps> = ({
  onConfirm,
  onCancel,
  isLoading = false,
}) => (
  <SheetModal isOpen>
    <Box p="3">
      <Button.Group wide>
        <Button onClick={onConfirm} disabled={isLoading}>
          Hide this notification
        </Button>
        <Button outlined onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
      </Button.Group>
    </Box>
  </SheetModal>
);

export default HideNotificationSheet;
